// External modules
import acHTTPClient from 'services/ACHTTPClient';

// internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

const limit = config.limit.bookings || config.limit.default;

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;;
const notificationAPIURL = `${config.notificationAPIURL}`;

const getBookingNotificationDataError = (error) => {
  return {
    type: constants.GET_BOOKING_NOTIFICATION_DATA_ERROR,
    error,
  };
};

const getBookingNotificationDataSuccess = (notificationDataResponse) => {
  return {
    type: constants.GET_BOOKING_NOTIFICATION_DATA_SUCCESS,
    notificationDataResponse,
  };
};

const getBookingsError = (error) => {
  return {
    type: constants.GET_BOOKINGS_ERROR,
    error,
  };
};

const getBookingsSuccess = (bookingResponse) => {
  return {
    type: constants.GET_BOOKINGS_SUCCESS,
    bookingResponse,
  };
};

const postPreviewConfirmationError = (error) => {
  return {
    type: constants.POST_PREVIEW_CONFIRMATION_ERROR,
    error,
  };
};

const postPreviewConfirmationSuccess = (html) => {
  return {
    type: constants.POST_PREVIEW_CONFIRMATION_SUCCESS,
    html: html,
  };
};

const postBookingNotificationError = (error) => {
  return {
    type: constants.POST_BOOKING_NOTIFICATION_SUCCESS,
    error,
  };
};

const postBookingNotificationSuccess = (status) => {
  return {
    type: constants.POST_BOOKING_NOTIFICATION_SUCCESS,
    status,
  };
};

const postSendConfirmationError = (error) => {
  return {
    type: constants.POST_SEND_CONFIRMATION_SUCCESS,
    error,
  };
};

const postSendConfirmationSuccess = (isConfirmationSent) => {
  return {
    type: constants.POST_SEND_CONFIRMATION_SUCCESS,
    isConfirmationSent: isConfirmationSent,
  };
};

const postSendCodeError = (error) => {
  return {
    type: constants.POST_SEND_CODE_ERROR,
    error,
  };
};

const postSendCodeSuccess = (isCodeSent) => {
  return {
    type: constants.POST_SEND_CODE_SUCCESS,
    isCodeSent: isCodeSent,
  };
};

const postBookingItemPaymentError = (error) => {
  return {
    type: constants.POST_BOOKING_ITEM_PAYMENT_ERROR,
    error,
  };
};

const postBookingItemPaymentSuccess = (postPaymentStatus) => {
  return {
    type: constants.POST_BOOKING_ITEM_PAYMENT_SUCCESS,
    postPaymentStatus: postPaymentStatus,
  };
};

const postBookingItemActivityError = (error) => {
  return {
    type: constants.POST_BOOKING_ITEM_ACTIVITY_ERROR,
    error,
  };
};

const postBookingItemActivitySuccess = (postActivityStatus) => {
  return {
    type: constants.POST_BOOKING_ITEM_ACTIVITY_SUCCESS,
    postActivityStatus: postActivityStatus,
  };
};

const patchBookingError = (error) => {
  return {
    type: constants.PATCH_BOOKING_ERROR,
    error,
  };
};

const patchBookingSuccess = (booking) => {
  return {
    type: constants.PATCH_BOOKING_SUCCESS,
    booking: booking,
  };
};

const patchBookingsError = (error) => {
  return {
    type: constants.PATCH_BOOKINGS_ERROR,
    error,
  };
};

const patchBookingsSuccess = (booking) => {
  return {
    type: constants.PATCH_BOOKINGS_SUCCESS,
    booking: booking,
  };
};

const patchBookingsRefreshSuccess = (booking) => {
  return {
    type: constants.PATCH_BOOKINGS_REFRESH,
    booking: booking,
  };
};

const patchBookingStopsOrderError = (error) => {
  return {
    type: constants.PATCH_BOOKING_STOPS_ORDER_ERROR,
    error,
  };
};

const patchBookingStopsOrderSuccess = (booking) => {
  return {
    type: constants.PATCH_BOOKING_STOPS_ORDER_SUCCESS,
    booking: booking,
  };
};

const putBookingItemPriceError = (error) => {
  return {
    type: constants.PUT_BOOKING_ITEM_PRICE_ERROR,
    error,
  };
};

const putBookingItemPriceSuccess = (status) => {
  return {
    type: constants.PUT_BOOKING_ITEM_PRICE_SUCCESS,
    status,
  };
};

const putBookingStopError = (error) => {
  return {
    type: constants.PUT_BOOKING_STOP_ERROR,
    error,
  };
};

const putBookingStopSuccess = (status) => {
  return {
    type: constants.PUT_BOOKING_STOP_SUCCESS,
    status,
  };
};

const deleteOneBookingStopProviderError = (error) => {
  return {
    type: constants.DELETE_ONE_BOOKING_STOP_PROVIDER_ERROR,
    error,
  };
};

const deleteOneBookingStopProviderSuccess = (status) => {
  return {
    type: constants.DELETE_ONE_BOOKING_STOP_PROVIDER_SUCCESS,
    status,
  };
};

const deleteOneBookingStopSparkError = (error) => {
  return {
    type: constants.DELETE_ONE_BOOKING_STOP_SPARK_ERROR,
    error,
  };
};

const deleteOneBookingStopSparkSuccess = (status) => {
  return {
    type: constants.DELETE_ONE_BOOKING_STOP_SPARK_SUCCESS,
    status,
  };
};

const putBookingManagerError = (error) => {
  return {
    type: constants.PUT_BOOKING_MANAGER_ERROR,
    error,
  };
};

const putBookingManagerSuccess = (response) => {
  return {
    type: constants.PUT_BOOKING_MANAGER_SUCCESS,
    response,
  };
};

const putBookingDeliveryStatusError = (error) => {
  return {
    type: constants.PUT_BOOKING_DELIVERY_STATUS_ERROR,
    error,
  };
};

const putBookingDeliveryStatusSuccess = (response) => {
  return {
    type: constants.PUT_BOOKING_DELIVERY_STATUS_SUCCESS,
    response,
  };
};

const putBookingIsPersonalisedError = (error) => {
  return {
    type: constants.PUT_BOOKING_IS_PERSONALISED_ERROR,
    error,
  };
};

const putBookingIsPersonalisedSuccess = (response) => {
  return {
    type: constants.PUT_BOOKING_IS_PERSONALISED_SUCCESS,
    response,
  };
};
const patchStopBookingNoteError = (error) => {
  return {
    type: constants.PUT_STOP_BOOKING_NOTES_ERROR,
    error,
  };
};

const patchStopBookingNoteSuccess = (success) => {
  return {
    type: constants.PUT_STOP_BOOKING_NOTES_SUCCESS,
    success,
  };
};

const deleteOneBookingRouteError = (error) => {
  return {
    type: constants.DELETE_ONE_BOOKING_ROUTE_ERROR,
    error,
  };
};

const deleteOneBookingRouteSuccess = (success) => {
  return {
    type: constants.DELETE_ONE_BOOKING_ROUTE_SUCCESS,
    success,
  };
};

const deleteOneBookingVirtualError = (error) => {
  return {
    type: constants.DELETE_ONE_BOOKING_VIRTUAL_ERROR,
    error,
  };
};

const deleteOneBookingVirtualSuccess = (success) => {
  return {
    type: constants.DELETE_ONE_BOOKING_VIRTUAL_SUCCESS,
    success,
  };
};

const clearBookingError = () => {
    return {
        type : constants.CLEAR_ERROR,
    }
}

const getBookings = (filterParams) => {
  let apiURL = `${experienceAPIURL}/bookings?limit=${limit}&isPagination=true&doexpensiveapicalls=true`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1);
  }
  return async (dispatch) => {
    dispatch({ type: constants.GET_BOOKING_ATTEMPT });
    const config = { url: apiURL, method: 'GET' };
    try {
      const response = await acHTTPClient.request(config);
      if (!response.data || response.data.error) {
        dispatch(getBookingsError(response.statusText));
      }
      dispatch(getBookingsSuccess(response.data));
    } catch (error) {
      onAuthError(error);
      dispatch(getBookingsError(error));
    }
  };
};

const getBookingNotificationData = (bookingId, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/notification`;
  // A component booking is only addressable together with its occasion.
  if (occasionBookingId) apiURL += `?occasionBookingId=${occasionBookingId}`;
  return async (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    try {
      const response = await acHTTPClient.request(config);
      if (!response.data || response.data.error) {
        return dispatch(getBookingNotificationDataError(response.statusText));
      }
      return dispatch(getBookingNotificationDataSuccess(response.data));
    } catch (error) {
      onAuthError(error);
      return dispatch(getBookingNotificationDataError(error));
    }
  };
};

const postPreviewConfirmation = (confirmationBody) => {
  let apiURL = `${notificationAPIURL}/api/v1/notification/presentation`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data: confirmationBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postPreviewConfirmationError(response.statusText));
        }
        dispatch(postPreviewConfirmationSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postPreviewConfirmationError(error));
      });
  };
};

// This sends the confirmation email.
const postSendConfirmation = (confirmationBody, actorData, bookingId) => {
    let apiURL1 = `${experienceAPIURL}/bookings/${bookingId}/notification/queue/confirmations`;
    confirmationBody.email.bookingId = bookingId;
    confirmationBody.email.notificationId = actorData.id;
    const actionType = "sendconfirmation";
    confirmationBody.email.actionType = actionType;
    confirmationBody.actionType = actionType;
    return (dispatch) => {
        const config1 = { url: apiURL1, method: 'POST', data: { actor: actorData, confirmation: confirmationBody } };
        acHTTPClient
            .request(config1)
            .then((response) => {
                if (!response.data || response.data.error) {
                    dispatch(postSendConfirmationError(response.statusText));
                }
                dispatch(postSendConfirmationSuccess(response.data.data));
                dispatch(postBookingNotificationSuccess(response.data.data));
            })
            .catch((error) => {
                dispatch(postSendConfirmationError(error));
            });
    };
};

// This updates the booking notification object.
const postBookingNotification = (bookingId, confirmationsOrCodes, data) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/notification/${confirmationsOrCodes}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postBookingNotificationError(response.statusText));
        }
        dispatch(postBookingNotificationSuccess(response.data.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(postBookingNotificationError(error));
      });
  };
};

const postSendCode = (codeBody, booking, actorData) => {
    return async (dispatch) => {
        try {
        let statusAPIUrL = `${experienceAPIURL}/bookings/${booking.id}/delivery-status/queue`;
        codeBody.email.bookingId = booking.id;
        const actionType = "sendcode";
        codeBody.email.actionType = actionType;
        codeBody.actionType = actionType;
        const statusPayload = { url: statusAPIUrL, method: 'POST' , data : {deliveryStatus : "AVAILABLE", deliveryQueueStatus: "CREATED", confirmation: codeBody }};
        const deliveryStatusResponse = await acHTTPClient.request(statusPayload)
        if (!deliveryStatusResponse || !deliveryStatusResponse.data || deliveryStatusResponse.data.error) {
            const error = {
                message : 'NotificationAPI Failure : ' + deliveryStatusResponse?.statusText || 'NO RESPONSE',
                requestData : statusPayload,
                responseData : deliveryStatusResponse
            }
            dispatch(putBookingDeliveryStatusError({ error, booking}));
            return Promise.reject(error);
        }

        // The delivery-status queue endpoint records the status but not the codes
        // notification (unlike the bulk endpoint, which writes one server-side).
        // Occasions need it written to move the header button off "not actioned",
        // so record it here. Scoped to occasions: legacy bookings keep relying on
        // whoever wrote their codes entry before, so no duplicate entries appear.
        if (actorData && booking.isOccasion) {
            const notificationURL = `${experienceAPIURL}/bookings/${booking.id}/notification/codes`;
            await acHTTPClient
                .request({ url: notificationURL, method: 'POST', data: actorData })
                .catch((error) => {
                    console.error('Failed recording codes notification for booking ' + booking.id, error);
                });
        }

        dispatch(putBookingDeliveryStatusSuccess(deliveryStatusResponse.data));
        dispatch(postSendCodeSuccess(deliveryStatusResponse.data));
        } catch (error) {
            console.error('Notification API General failure ', error);
            dispatch(postSendCodeError({error, booking, shouldDisplay : true}));
            dispatch(putBookingDeliveryStatusError({error, booking}));
        }
    };
};

const patchBooking = (booking) => {
  let apiURL = `${experienceAPIURL}/bookings/${booking.id}`;
  let patchBody = {
    ...booking,
  };

  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: patchBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchBookingError(response.statusText));
        }
        dispatch(patchBookingSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchBookingError(error));
      });
  };
};


const patchBookingsRoute = (bookingIds,routeId) => {
  let apiURL = `${experienceAPIURL}/bookings/route-attach`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: {bookingIds,routeId} };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchBookingsError(response.statusText));
        }
        dispatch(patchBookingsSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchBookingError(error));
      });
  };
};

const bookingSuccess = (value) =>{
  return (dispatch)=>{
    dispatch(patchBookingsRefreshSuccess(value))
  }
  
}

const patchBookingStopsOrder = (booking) => {
  let apiURL = `${experienceAPIURL}/bookings/${booking.id}/stops-order`;
  let patchBody = {
    ...booking
  };  
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: patchBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchBookingStopsOrderError(response.statusText));
        }
        dispatch(patchBookingStopsOrderSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchBookingError(error));
      });
  };
};

/**
 * Add Note to the booking
 * @param {*} bookingId  The booking ID
 * @param {*} notes  The note to be added
 */
const patchBookingNote = (bookingId, note, dateTime = null) => {
  const apiURL = `${experienceAPIURL}/bookings/${bookingId}/note`;
  return async (dispatch) => {
    const config = {
      url: apiURL,
      method: 'PATCH',
      data: { note, dateTime, noteType: 'private' },
    };
    try {
      const response = await acHTTPClient.request(config);
      if (!response.data || response.data.error) {
        dispatch(patchBookingError(response.statusText));
      }
      dispatch(patchBookingSuccess(response.data));
    } catch (error) {
      onAuthError(error);
      dispatch(patchBookingError(error));
    }
  };
};

const putBookingItemPrice = (bookingId, itemId, price, tax, occasionBookingId) => {
  const priceNumber = Number(price);
  if (!priceNumber) {
    console.error('Error converting price to Number');
  }

  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/items/${itemId}/price`;
  // An occasion's component bookings are embedded and cannot be addressed by _id, so the
  // occasion has to travel with the id — the payment and activity writes already do this.
  let patchBody = {
    price: priceNumber,
    tax,
    occasionBookingId,
  };

  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT', data: patchBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingItemPriceError(response.statusText));
        }
        dispatch(putBookingItemPriceSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingItemPriceError(error));
      });
  };
};

/**
 * Records which of a component's allowed provider items delivers this booking.
 *
 * A partner component allows a set - several balloon operators, each with their own options -
 * and its stop is seeded empty precisely so this stays a delivery-time choice. aex refuses an
 * item the component does not allow, and fills the stop's provider, item and price from the one
 * chosen, so nobody has to type the cost.
 */
const patchComponentStopProviderItem = (bookingId, itemId, occasionBookingId) => {
  const apiURL = `${experienceAPIURL}/bookings/${bookingId}/component-stop/provider-item`;

  return (dispatch) => {
    const config = {
      url: apiURL,
      method: 'PATCH',
      // An occasion's component bookings are embedded and cannot be addressed by _id, so the
      // occasion travels with the id — the price and payment writes already do this.
      data: { itemId, occasionBookingId },
    };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchBookingError(response.statusText));
          return;
        }
        dispatch(patchBookingSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchBookingError(error));
      });
  };
};

const putBookingStop = (bookingId, stop, stopIndex) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/stops/${stopIndex}/`;
  let patchBody = stop;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT', data: patchBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingStopError(response.statusText));
        }
        dispatch(putBookingStopSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingStopError(error));
      });
  };
};

const patchBookingPublished = (booking, isPublished) => {
  let apiURL = `${experienceAPIURL}/bookings/${booking.id}/publishable`;
  const newDate = new Date().toISOString();
  let patchBody = {
    isPublished: isPublished,
    lastPublishedAt: isPublished ? newDate : null,
    showPublishBtn: false
  };
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: patchBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingStopError(response.statusText));
        }
        dispatch(putBookingStopSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingStopError(error));
      });
  };
};

const patchBookingPublishable = (booking, isPublishable, isSwap) => {
  let apiURL;
  if(!isSwap){
    apiURL = `${experienceAPIURL}/bookings/${booking.id}/publishable`;
  } else{
    apiURL = `${experienceAPIURL}/bookings/${booking.id}/stops-order`;
  }  
  let patchBody;
  if(!isSwap){
    patchBody = {
      showPublishBtn: isPublishable
    }
  } else{
  patchBody = {
    ...booking,
    showPublishBtn: isPublishable
  }
}

  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: patchBody };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingStopError(response.statusText));
        }
        if(isSwap){
          dispatch(putBookingStopSuccess(response.data));
        }
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingStopError(error));
      });
  };
};

const deleteOneBookingStopProvider = (bookingId, providerId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/stops/provider/${providerId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'DELETE' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(deleteOneBookingStopProviderError(response.statusText));
        }
        dispatch(deleteOneBookingStopProviderSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(deleteOneBookingStopProviderError(error));
      });
  };
};

const deleteOneBookingStopSpark = (bookingId, sparkId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/stops/spark/${sparkId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'DELETE' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(deleteOneBookingStopSparkError(response.statusText));
        }
        dispatch(deleteOneBookingStopSparkSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(deleteOneBookingStopSparkError(error));
      });
  };
};

const postBookingItemPayment = (bookingId, itemId, data, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/items/${itemId}/payments`;
  // A component booking is only addressable together with its occasion.
  if (occasionBookingId) apiURL += `?occasionBookingId=${occasionBookingId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postBookingItemPaymentError(response.statusText));
        }
        dispatch(postBookingItemPaymentSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(postBookingItemPaymentError(error));
      });
  };
};

const postBookingItemActivity = (bookingId, itemId, stopNumber, dataActivity, note, occasionBookingId) => {
  // A component booking is only addressable together with its occasion.
  const occasionQuery = occasionBookingId ? `?occasionBookingId=${occasionBookingId}` : '';
  let apiURLActivity = `${experienceAPIURL}/bookings/${bookingId}/items/${itemId}/activities${occasionQuery}`;
  let apiURLNote = `${experienceAPIURL}/bookings/${bookingId}/stops/${stopNumber}/note/private${occasionQuery}`;


  return async (dispatch) => {
    try {
      let responseActivity = await acHTTPClient.request({ url: apiURLActivity, method: 'POST', data : dataActivity })
      if (!responseActivity.data || responseActivity.data.error) {
        dispatch(postBookingItemActivityError(responseActivity.statusText));
        return;
      }
      let responseNote = await acHTTPClient.request({ url: apiURLNote, method: 'PATCH', data : { note : note } })
      if (!responseNote.data || responseNote.data.error) {
        dispatch(postBookingItemActivityError(responseNote.statusText));
        return;
      }

      dispatch(postBookingItemActivitySuccess(responseActivity.data));
      return;
    } catch(error) {
        onAuthError(error);
        dispatch(postBookingItemActivityError(error));
    };
  };
};

const toBase64 = (file) =>  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload  = () => resolve((reader.result).split(',')[1]); // strip data:...;base64,
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/**
 * The booking's ticket documents with short-lived presigned URLs, for the planner's
 * preview. Returns null on failure so the caller can treat "no tickets" and "couldn't
 * load" the same way.
 */
const fetchBookingTickets = async (bookingId, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/tickets`;
  if (occasionBookingId) apiURL += `?occasionBookingId=${occasionBookingId}`;

  return await acHTTPClient
    .request({ url: apiURL, method: 'GET' })
    .then((response) => response.data?.data ?? null)
    .catch((error) => {
      onAuthError(error);
      return null;
    });
};

/**
 * Attach tickets to one stop of a booking's route. `data` is
 * { note, files, removedFiles, time, occasionBookingId } — an object rather than the
 * positional list it used to be, which had already run to six arguments.
 *
 * A stop is the unit a ticket belongs to: a component can be a multi-stop experience where
 * only some stops are ticketed, and a component that is a single stop by nature is ticketed
 * through stop 0 of the one-stop route it is seeded with at HQ sync.
 */
const postBookingStopTicket = (bookingId, stopNumber, data = {}) => {
  const apiURL = `${experienceAPIURL}/bookings/${bookingId}/stops/${stopNumber}/ticket`;

  return async (dispatch) => {
    try {
      const filesPayload = await Promise.all(
        (data.files || []).map(async (file) => ({
          name: file.name,
          type: file.type,
          size: file.size,
          data: await toBase64(file),
        }))
      );

      const response = await acHTTPClient.request({
        url: apiURL,
        method: 'PATCH',
        data: {
          note: data.note ?? '',
          files: filesPayload,
          removedFiles: data.removedFiles || [],
          // Explicit null clears it; the API leaves the stored time alone only when the
          // field is absent, which is what a documents-only caller relies on.
          time: data.time || null,
          // A component booking's id is shared by every booking of its package, so the
          // occasion it belongs to has to travel with it.
          occasionBookingId: data.occasionBookingId,
        },
      });

      if (!response.data || response.data.error) {
        dispatch(postBookingItemActivityError(response.statusText));
        return;
      }

      // Shares the success action so the planner reloads the booking — the stop list
      // is built when the booking details mount, so it needs fresh data to show up.
      dispatch(postBookingItemActivitySuccess(response.data));
    } catch (error) {
      onAuthError(error);
      dispatch(postBookingItemActivityError(error));
    }
  };
};

// An occasion's component bookings are embedded and cannot be addressed by _id, so the
// occasion has to travel with the id — the same as every other component write. The
// endpoint takes no body, so it rides as a query parameter.
const putBookingManager = (bookingId, userId, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/users/${userId}`;
  if (occasionBookingId) apiURL += `?occasionBookingId=${occasionBookingId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingManagerError(response.statusText));
        }
        dispatch(putBookingManagerSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingManagerError(error));
      });
  };
};

// Clearing a delivery manager. Shares putBookingManager's success/error creators so the
// reducer's existing refreshBookings case reloads the planner either way.
const deleteBookingManager = (bookingId, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/users`;
  if (occasionBookingId) apiURL += `?occasionBookingId=${occasionBookingId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'DELETE' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingManagerError(response.statusText));
        }
        dispatch(putBookingManagerSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingManagerError(error));
      });
  };
};

const putBookingDeliveryStatus = (bookingId, deliveryStatus) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/delivery-status`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT' , data : {deliveryStatus}};
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingDeliveryStatusError(response.statusText));
        }
        dispatch(putBookingDeliveryStatusSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingDeliveryStatusError(error));
      });
  };
};

// TEST AFFORDANCE: force a booking to "ready for delivery" (AVAILABLE + queue SENT)
// with no route/component checks and without sending any email, so the on-the-day
// features can be exercised. Uses the existing mark-available endpoint, which also
// propagates the status to the events API.
const postBookingMarkAvailable = (bookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/delivery-status/mark-available`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'POST' };
    return acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingDeliveryStatusError(response.statusText));
          return;
        }
        dispatch(putBookingDeliveryStatusSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingDeliveryStatusError(error));
      });
  };
};

const putBookingIsPersonalised = (bookingId, isPersonalised) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/isPersonalised`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT' , data : {isPersonalised}};
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putBookingIsPersonalisedError(response.statusText));
        }
        dispatch(putBookingIsPersonalisedSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putBookingIsPersonalisedError(error));
      });
  };
};



const patchStopBookingNote = (bookingId, stopNumber, note) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/stops/${stopNumber}/note/private`;
  let data = {
    note,
  };

  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchStopBookingNoteError(response.statusText));
        }
        dispatch(patchStopBookingNoteSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchStopBookingNoteError(error));
      });
  };
};

const deleteOneBookingRoute = (bookingId, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/route`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'DELETE', data: { occasionBookingId } };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(deleteOneBookingRouteError(response.statusText));
        }
        dispatch(deleteOneBookingRouteSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(deleteOneBookingRouteError(error));
      });
  };
};


const deleteBookingsRoute = (bookingIds) => {
  let apiURL = `${experienceAPIURL}/bookings/delete-routes`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: bookingIds};
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(deleteOneBookingRouteError(response.statusText));
        }
        dispatch(deleteOneBookingRouteSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(deleteOneBookingRouteError(error));
      });
  };
};

const deleteOneBookingVirtual = (bookingId, occasionBookingId) => {
  let apiURL = `${experienceAPIURL}/bookings/${bookingId}/virtual`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'DELETE', data: { occasionBookingId } };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(deleteOneBookingVirtualError(response.statusText));
        }
        dispatch(deleteOneBookingVirtualSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(deleteOneBookingVirtualError(error));
      });
  };
};


export {
  getBookings,
  getBookingNotificationData,
  postPreviewConfirmation,
  postSendConfirmation,
  postSendCode,
  patchBooking,
  putBookingItemPrice,
  patchComponentStopProviderItem,
  postBookingItemPayment,
  postBookingItemActivity,
  postBookingNotification,
  patchStopBookingNote,
  postBookingStopTicket,
  fetchBookingTickets,
  putBookingManager,
  deleteBookingManager,
  putBookingStop,
  patchBookingPublishable,
  patchBookingPublished,
  deleteOneBookingStopProvider,
  deleteOneBookingStopSpark,
  patchBookingNote,
  deleteOneBookingRoute,
  deleteOneBookingVirtual,
  putBookingDeliveryStatus,
  putBookingDeliveryStatusError,
  putBookingDeliveryStatusSuccess,
  postBookingMarkAvailable,
  patchBookingStopsOrder,
  clearBookingError,
  patchBookingsRoute,
  deleteBookingsRoute,
  bookingSuccess,
  putBookingIsPersonalised
};
